<template>
    <div style="background-color: #F3F4F9">
        <van-list v-if="!indicatorType" v-model="loading"
                  :finished="finished"
                  finished-text="没有更多了"
                  @load="getData">
            <!--            "-->
            <van-swipe-cell :disabled="listType!=='2'" :stop-propagation="true"
                v-for="(item, i) in list"
                :style="{'margin-top': i == 0 ? '7px' : '0px'}"
                :key="i"
                >
<!--                :right-width="getRightWidth(item)">-->
                <div @click="clickEvent(item, i)" class="list-item">
                    <div class="list-item-initiator-layout flex-box-0">
                        <img class="portrait-shape" style="width: 36px; height: 36px"
                             :src="(item.userDetails && item.userDetails[item.profileId]) ? item.userDetails[item.profileId].portraitImgUrl : require('../../assets/img/default_portrait.png')">
                        <div class="list-item-initiator">
                            {{item.userDetails && item.userDetails[item.profileId] ?
                            item.userDetails[item.profileId].realName : ''}}
                        </div>
                    </div>
                    <div class="list-item-detail  flex-box-1">
                        <div class="list-item-detail-type">
                            <span>{{item.title || item.approveName}}</span>&nbsp;
                            <span style="color: #A4AFBC; font-size: 12px; transform: scale(0.9);">{{moment(item.createdTime).format('YYYY.MM.DD')}}</span>
                        </div>
                        <div v-if="item.attrs && item.attrs.length > 0" style="margin-top: 4px">
                            <div class="cell-attr"
                                 v-for="(val, i) in showContents(item).arr"
                                 :key="i">{{val.label}}:{{val.value}}
                            </div>
                        </div>
                        <van-button
                            v-if="listType=='-1' && item.approveType=='2' && item.statusCd=='1' && $store.state.hasApproveManage"
                            plain type="primary" size="small" @click.stop="forceClick(item.id, 1)">强制完结
                        </van-button>
                        <van-button
                            v-if="listType=='-1' && item.approveType=='2' && item.statusCd=='1' && $store.state.hasApproveManage"
                            plain type="danger" size="small" style="margin-left: 10px"
                            @click.stop="forceClick(item.id, 2)">
                            强制收回
                        </van-button>
                    </div>
                    <div class="flex-box-0">
                        <div class="list-item-status" v-if="item.statusCd == '1'">
                            <img src="../../assets/img/list/icon.png"
                                 style="width: 26px; height: 26px; margin-bottom: 6px">
                            <div class="approve-pending-color">审批中</div>
                        </div>
                        <div class="list-item-status" v-if="item.statusCd == '2'">
                            <img src="../../assets/img/list/矢量智能对象.png"
                                 style="width: 26px; height: 26px; margin-bottom: 6px">
                            <div class="approve-reject-color">未通过</div>
                        </div>
                        <div class="list-item-status" v-if="item.statusCd == '3'">
                            <img src="../../assets/img/list/已同意.png"
                                 style="width: 26px; height: 26px; margin-bottom: 6px">
                            <div class="approve-agree-color">已同意</div>
                        </div>
                        <div class="list-item-status" v-if="item.statusCd == '5'">
                            <img src="../../assets/img/list/已撤销.png"
                                 style="width: 26px; height: 26px; margin-bottom: 6px">
                            <div class="approve-withdrawn-color">已撤销</div>
                        </div>
                    </div>
                    <div v-if="isChoice" class="flex-box-0" style="margin-left: 10px">
                        <van-checkbox v-model="item.isSelected" @click.stop="clickEvent(item, i)"></van-checkbox>
                    </div>
                </div>
                <template #right>
                    <van-button v-if="item.topTime" style="height: 100%; background-color: #07AFFA;" @click="onClose(item, i, 'no-top')" square>
                        <span style="font-size: 15px; color: #FFFFFF;" >取消置顶</span>
                    </van-button>
                    <van-button v-else  style="height: 100%; background-color:#07AFFA;" @click="onClose(item, i, 'top')" square >
                        <span style="font-size: 15px; color: #FFFFFF;" >置顶</span>
                    </van-button>
                    <van-button v-if="item.statusCd === '1'" style="height: 100%; background-color:#FF9E00" @click="onClose(item, i, 'hasten')"  square >
                        <span style="font-size: 15px; color: #FFFFFF;" >催办</span>
                    </van-button>
                </template>
            </van-swipe-cell>
        </van-list>
        <div v-if="indicatorType" style="height: 80vh; display: flex; flex-direction: row; align-items: center">
            <indicatorEmpty :type="indicatorType" :message="indicatorMessage"></indicatorEmpty>
        </div>
    </div>
</template>

<script>
    import indicatorEmpty from './empty';
    import { Notify } from 'vant';
    export default {
        components: {
            indicatorEmpty
        },
        name: 'approve-list-compnent',
        // mixins: [head],
        data() {
            return {
                listType: '',
                loading: false,
                finished: false,
                list: [],
                page: 1,
                pagesize: 10,
                time: '',
                uniqueId: '',
                indicatorType: 0,
                indicatorMessage: ''
            };
        },
        props: {
            type: {
                default: ''
            },
            isChoice: {
                type: Boolean,
                default: false
            },
            selected: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            search: {
                type: Object,
                default: function () {
                    return {
                        status: '',
                        type: '',
                        content: '',
                        sort: 'DESC'
                    };
                }
            }
        },
        watch: {
            '$route': 'routeChanged',
            'type': function () {
                // console.log('watch-type执行了inited');
                this.inited();
            },
            'selected': function () {
                for (let i = 0; i < this.list.length; i++) {
                    this.list[i].isSelected = this.isSelected(this.list[i]);
                }
            },
            'search': function (val, oval) {
                // console.log('watch-search执行了inited');
                if (val.status != oval.status || val.type != oval.type || val.content != oval.content || val.sort != oval.sort) {
                    // console.log('watch-search执行了inited');
                    this.inited();
                }
            }

        },
        computed: {},
        mounted() {
            // console.log('listCompnent-mounted');
            this.routeChanged();
        },
        methods: {
            showContents(row) {
                let showContent = [];
                let labels = ['金额', '余额', '应付款增加', '应付款减少', '应收款增加', '应收款减少'];
                if (row.showContent) {
                    showContent = JSON.parse(row.showContent);
                    if (showContent.length) {
                        showContent = showContent.map((m) => {
                            let obj = {
                                label: m.label,
                                value: m.value
                            };
                            let flag = false;
                            for (let i = 0; i < labels.length; i++) {
                                if (obj.label.indexOf(labels[i]) != -1) {
                                    flag = true;
                                    break;
                                }
                            }
                            if (flag && row.approveName && row.approveName.indexOf('自动') != -1 && row.approveName.indexOf('审批') != -1) {
                                if (parseFloat(obj.value)) {
                                    obj.value = parseFloat(parseFloat(obj.value) / 100).toFixed(2);
                                } else {
                                    obj.value = parseFloat(obj.value).toFixed(2);
                                }
                            }
                            return obj;
                        });
                    }
                }
                return {
                    'arr': showContent
                };
            },
            routeChanged() {
                // console.log('listComponent routeChanged::::::::::', this.$route.name);
                if (this.$route.name == 'approve-list') {
                    if (this.time != this.$route.query.time) {
                        this.time = _.cloneDeep(this.$route.query.time);
                        this.inited();
                    }
                    if (window.refreshList) {
                        this.inited();
                    }
                } else if (this.$route.name == 'approve-choice') {
                    this.inited();
                }
            },

            inited() {
                this.indicatorType = 0;
                this.indicatorMessage = '';
                this.loading = false;
                this.finished = false;
                this.list = [];
                this.page = 1;
                this.listType = this.type;
                this.uniqueId = new Date().getTime() + '-' + Math.floor((Math.random() * 1000));
                console.log('uniqueId', this.uniqueId, this.listType);
                this.getData();
            },

            refresh() {
                this.inited();
            },

            getData() {
                let url = '';
                // this.listType = '1-1';
                if (this.listType == '1-0') { //待我审批
                    // url = 'badu/eaa/pageNeedMeApprove.do';
                    url = 'badu/eaa/pageListNeedMeApprove.do';
                } else if (this.listType == '1-1') { //我已审批
                    // url = 'badu/eaa/pageMyHistoryApprove.do';
                    url = 'badu/eaa/pageListMyHistoryApprove.do';
                } else if (this.listType == '2') { //我发起的
                    // url = 'badu/eaa/pageMyApprove.do';
                    url = 'badu/eaa/pageListMyApprove.do';
                } else if (this.listType == '3-0') { //抄送我的
                    url = 'badu/eaa/pageNotifyMeApprove.do';
                } else if (this.listType == '3-1') { //抄送我的未读
                    url = 'badu/eaa/pageNotifyMeApproveUnRead.do';
                } else if (this.listType == '4') { //归档给我的审批
                    url = 'badu/eaa/pagePigeonholeMeApprove_V2.do';
                } else if (this.listType == '5-0') { //转发给我
                    url = 'badu/eaa/pageTranspondMeApprove.do';
                } else if (this.listType == '5-1') { //转发给我未读
                    url = 'badu/eaa/pageTranspondMeApproveUnRead.do';
                } else if (this.listType == '-1') { //流程监控
                    // url = 'badu/eaa/pageCanManageApprove.do';
                    url = 'badu/eaa/pageListCanManageApprove.do';
                } else {
                    return;
                }
                let param = {
                    page: this.page,
                    pagesize: 10,
                    searchName: this.search.content || '',
                    approveIds: this.search.type || '',
                    statusCds: this.search.status || '',
                    createOrder: this.search.sort || 'DESC',
                    createTimeSort: 'createTime'
                };
                console.log('param', param);
                // this.loading = true;
                this.$http.post(url, param, { uniqueId: this.uniqueId, toast: true })
                    .then((response) => {
                        if (response.request.uniqueId != this.uniqueId || this.page != param.page) {
                            return;
                        }
                        this.page++;
                        // console.log(response.data);
                        if (response.data.result.length < 10) {
                            this.finished = true;
                        } else {
                            this.finished = false;
                        }
                        for (let i = 0; i < response.data.result.length; i++) {
                            let item = response.data.result[i];

                            item.attrs = item.showContent ? JSON.parse(item.showContent) : [];
                            item.isSelected = this.isSelected(item);
                            this.list.push(item);
                        }
                        this.loading = false;
                        if (this.list && this.list.length > 0) {
                            this.indicatorType = 0;
                        } else {
                            this.indicatorType = 2;
                            switch (this.listType) {
                                case 1:
                                case 2:
                                    this.indicatorMessage = '还没有收到任何审批';
                                    break;
                                case 3:
                                    this.indicatorMessage = '还没有发起任何审批';
                                    break;
                                case 4:
                                case 5:
                                    this.indicatorMessage = '还没有收到任何抄送';
                                    break;
                            }
                        }
                    })
                    .catch((error) => {
                        console.log('aaaaaaaaaaaaaaa===>error', error);
                        if (error.request.uniqueId != this.uniqueId || this.page != param.page) {
                            return;
                        }
                        this.indicatorType = error.rspCode == -100 && (error.status != 403 || error.status != 500) ? 1 : 3;
                        this.indicatorMessage = error.rspMsg;
                        this.loading = false;
                        this.finished = false;
                    });
            },

            names(data) {
                try {
                    if (data.nowProcess.approvals.length == 1) {
                        return data.userDetails[data.nowProcess.approvals[0]].realName || '';
                    } else if (data.nowProcess.approvals.length > 1) {
                        return data.userDetails[data.nowProcess.approvals[0]].realName + '等' + data.nowProcess.approvals.length + '人' || '';
                    }
                } catch (e) {
                }
                return '';
            },

            forceClick(id, type) {
                this.PUSH({ name: 'flow-force-commit', query: { id: id, type: type } });
            },

            clickEvent(item, i) {
                console.log('approveType', item.approveType);
                if (this.isChoice) {
                    let exist = false;
                    for (let i = 0; i < this.selected.length; i++) {
                        if (item.id == this.selected[i]) {
                            exist = true;
                            break;
                        }
                    }
                    if (exist) {
                        this.$emit('disSelect', item);
                    } else {
                        this.$emit('select', item);
                    }
                } else {
                    if (item.approveType == '2') {
                        let param = { id: item.id, time: new Date().getTime() };
                        if (this.listType == '-1') {
                            param.formManage = true;
                        }
                        this.PUSH({ name: 'flow-detail', query: param });
                    } else {
                        this.PUSH({ name: 'approve-detail', query: { id: item.id, time: new Date().getTime() } });
                    }
                    if (this.listType == 5) {
                        // this.$http.post('badu/eaa/notifyNotifyMeApproveIsRead.do', { ids: item.id }, { uniqueId: this.uniqueId })
                        //     .then((response) => {
                        //         if (response.request.uniqueId != this.uniqueId) {
                        //             return;
                        //         }
                        this.list.splice(i, 1);
                        // });
                    }
                }
            },

            isSelected(item) {
                let exist = false;
                for (let i = 0; i < this.selected.length; i++) {
                    if (item.id == this.selected[i]) {
                        exist = true;
                        break;
                    }
                }
                return exist;
            },
            // eslint-disable-next-line no-unused-vars
            onClose(row, i, event) {
                let url = null;
                if (event === 'hasten') {
                    url = 'badu/eaa/hasten.do';
                } else if (event === 'top') {
                    url = 'badu/eaa/isTop.do';
                } else if (event === 'no-top') {
                    url = 'badu/eaa/isTop.do';
                }
                if (url) {
                    const { id } = row;
                    let isTop = true;
                    if (row.topTime) {
                        isTop = 1;
                    } else {
                        isTop = 0;
                    }
                    const param = {
                        id,
                        isTop
                    };
                    this.$http.post(url, param, { uniqueId: this.uniqueId, toast: true })
                        .then((response) => {
                            const data = response;
                            if (data.rspCode === 0) {
                                Notify({ type: 'success', message: data.data });
                            } else {
                                Notify({ type: 'warning', message: data.rspMsg });
                            }
                            if (event !== 'hasten') {
                                this.inited();
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            },
            getRightWidth(item) {
                let rightWidth = 0;
                if (item.statusCd === '1') {
                    if (item.topTime) {
                        rightWidth = 172;
                    } else {
                        rightWidth = 141;
                    }
                } else if (item.topTime) {
                    rightWidth = 108;
                } else {
                    rightWidth = 78;
                }
                return rightWidth;
            }
        }
    };
</script>

<style lang="scss"
       scoped>
    @import '../../assets/scss/approve.scss';

    .top {
        position: fixed;
        left: 0;
        top: 0;
    }

    .list-item {
        display: flex;
        padding: 15px 10px 15px 10px;
        margin: 0px 13px 10px 13px;
        border-radius: 5px;
        background-color: white;
        align-items: center;
        text-align: left;
        flex-direction: row;
    }

    .list-item-detail {
        margin-left: 12px;
        margin-right: 15px;
        min-height: 36px;
    }

    .list-item-detail-type {
        font-size: 15px;
        color: #28405E;
        line-height: 18px;
    }

    .list-item-detail-title {
        font-size: 13px;
        color: #28405E;
        margin-top: 6px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .cell-attr {
        width: 180px;
        color: #A4AFBC;
        font-size: 12px;
        padding-top: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .list-item-initiator-layout {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }

    .list-item-initiator {
        color: #596C83;
        text-align: center;
        font-size: 12px;
        margin-top: 6px;
        width: 40px;
        transform: scale(0.9);
        text-overflow: ellipsis;
        /*white-space: nowrap;*/
    }

    .list-item-status {
        font-size: 12px;
        width: 36px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
    }
</style>
